/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Причина проблемы по этапу заявки
 * @export
 * @enum {string}
 */
export enum ApplicationReasonWarning {
  FailedRegistrationDenied = 'REASON_FAILED_REGISTRATION_DENIED',
  WarningDuty = 'REASON_WARNING_DUTY',
  WarningDutyPayed = 'REASON_WARNING_DUTY_PAYED',
  WarningDutyRepeat = 'REASON_WARNING_DUTY_REPEAT',
  WarningDutyNotFound = 'REASON_WARNING_DUTY_NOT_FOUND',
  WarningFeRequest = 'REASON_WARNING_FE_REQUEST',
  WarningFeRequestAnswered = 'REASON_WARNING_FE_REQUEST_ANSWERED',
  WarningAdditionalResponseTime = 'REASON_WARNING_ADDITIONAL_RESPONSE_TIME',
  WarningMktuCheck = 'REASON_WARNING_MKTU_CHECK',
  WarningMktuCheckAnswered = 'REASON_WARNING_MKTU_CHECK_ANSWERED',
  WarningEosInvalidCheck = 'REASON_WARNING_EOS_INVALID_CHECK',
  WarningEosInvalidCheckAnswered = 'REASON_WARNING_EOS_INVALID_CHECK_ANSWERED',
  WarningEosFormatRequest = 'REASON_WARNING_EOS_FORMAT_REQUEST',
  WarningEosFormatRequestAnswered = 'REASON_WARNING_EOS_FORMAT_REQUEST_ANSWERED',
  WarningDutyRequired = 'REASON_WARNING_DUTY_REQUIRED',
  FailedUserApplicationReturn = 'REASON_FAILED_USER_APPLICATION_RETURN',
  FailedForceCancelDecision = 'REASON_FAILED_FORCE_CANCEL_DECISION',
}

export function instanceOfApplicationReasonWarning(value: any): boolean {
  for (const key in ApplicationReasonWarning) {
    if (Object.prototype.hasOwnProperty.call(ApplicationReasonWarning, key)) {
      if (
        ApplicationReasonWarning[
          key as keyof typeof ApplicationReasonWarning
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function ApplicationReasonWarningFromJSON(
  json: any
): ApplicationReasonWarning {
  return ApplicationReasonWarningFromJSONTyped(json, false)
}

export function ApplicationReasonWarningFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationReasonWarning {
  return json as ApplicationReasonWarning
}

export function ApplicationReasonWarningToJSON(
  value?: ApplicationReasonWarning | null
): any {
  return value as any
}
